import { call, delay, put } from 'typed-redux-saga';
import { OktaService } from '../../services/okta';
import { SettingsService } from '../../services/settings';
import { getContainer } from '../utils.saga';
import { authSlice } from './auth.slice';

export function* getAccessTokenSaga(): Generator<
  unknown,
  string | null,
  unknown
> {
  const container = yield* getContainer();
  const oktaService = container.get(OktaService);

  const accessToken: string | null = yield* call(async () =>
    oktaService.getAccessToken(),
  );

  if (!accessToken) {
    yield* put(
      authSlice.actions.setContinueRoutePostLogin(globalThis.location.pathname),
    );
    const { settings } = container.get(SettingsService);
    yield oktaService.oktaAuth.signInWithRedirect({
      maxAge: settings.loginMaxAgeSeconds,
    });
    yield* delay(1000);
  }
  return accessToken;
}
